import * as TableauUI from '@tableau/tableau-ui';
import * as React from 'react';
import { makeTestId } from '../utils/Declarative';
import { TextAreaAttrs } from '../utils/HtmlAttrs';

export interface TextAreaProps {
  /** NOTE: applied to the root `<div>`, not the `<input>`. */
  className?: string;
  /** Label to display above the field. */
  label: React.ReactNode;
  /**
   * The contents of the helper message under the field, if any.
   * Set to `<br />` to reserve vertical space for showing a validation message when `valid` is `undefined`.
   */
  message?: React.ReactNode;
  /** Added to the root `<div>` with the suffix `-TextArea` */
  testId: string;
  /**
   * * `undefined` or `null`: the field will be shown with normal coloring
   * * `"pending"`: the field will be shown with normal coloring and a loading animation
   * * `false`: the field will be shown with red coloring, and `aria-errormessage`/`aria-invalid` will be set on the `<input>`
   * * `true`: the field will be shown with green coloring
   * @default undefined
   */
  valid?: boolean | 'pending';
}

/** A drop-in replacement for a TEXTAREA element with standard styling, accessible label and validation messages, and focus indication. */
export const TextAreaWidget = React.forwardRef<HTMLTextAreaElement, TextAreaProps & TextAreaAttrs>((props, ref) => {
  const { testId, ...textAreaProps } = props;
  return <TableauUI.TextArea data-tb-test-id={makeTestId(testId, 'TextArea')} {...textAreaProps} ref={ref} />;
});
TextAreaWidget.displayName = 'TextAreaWidget';
